// source: finding_video.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var videostory_render_service_pb = require('./videostory/render_service_pb.js');
goog.object.extend(proto, videostory_render_service_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.displayName = 'proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.toObject = function(includeInstance, msg) {
  var f, obj = {
schema: jspb.Message.getFieldWithDefault(msg, 1, ""),
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 3, ""),
graphVersion: jspb.Message.getFieldWithDefault(msg, 4, ""),
look: jspb.Message.getFieldWithDefault(msg, 5, ""),
language: jspb.Message.getFieldWithDefault(msg, 6, ""),
videoKey: jspb.Message.getFieldWithDefault(msg, 7, ""),
renderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
attempt: jspb.Message.getFieldWithDefault(msg, 9, 0),
state: jspb.Message.getFieldWithDefault(msg, 10, 0),
stateDetail: jspb.Message.getFieldWithDefault(msg, 11, ""),
taskId: jspb.Message.getFieldWithDefault(msg, 12, ""),
tenant: jspb.Message.getFieldWithDefault(msg, 13, ""),
estimatedCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
maxCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
renderCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
chargedUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
billingSettled: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
delivery: (f = msg.getDelivery()) && proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.toObject(includeInstance, f),
knownDefectsList: jspb.Message.toObjectList(msg.getKnownDefectsList(),
    videostory_render_service_pb.KnownDefect.toObject, includeInstance),
failure: jspb.Message.getFieldWithDefault(msg, 21, ""),
render: (f = msg.getRender()) && videostory_render_service_pb.Render.toObject(includeInstance, f),
createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nextSubmitTime: (f = msg.getNextSubmitTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
capacityRetries: jspb.Message.getFieldWithDefault(msg, 26, 0),
holdPlaced: jspb.Message.getBooleanFieldWithDefault(msg, 27, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo;
  return proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchema(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLook(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoKey(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttempt(value);
      break;
    case 10:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateDetail(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenant(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEstimatedCostUsd(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxCostUsd(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRenderCostUsd(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChargedUsd(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBillingSettled(value);
      break;
    case 19:
      var value = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.deserializeBinaryFromReader);
      msg.setDelivery(value);
      break;
    case 20:
      var value = new videostory_render_service_pb.KnownDefect;
      reader.readMessage(value,videostory_render_service_pb.KnownDefect.deserializeBinaryFromReader);
      msg.addKnownDefects(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailure(value);
      break;
    case 22:
      var value = new videostory_render_service_pb.Render;
      reader.readMessage(value,videostory_render_service_pb.Render.deserializeBinaryFromReader);
      msg.setRender(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextSubmitTime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCapacityRetries(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoldPlaced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchema();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGraphVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLook();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVideoKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRenderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAttempt();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getStateDetail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTenant();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEstimatedCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getMaxCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getRenderCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getChargedUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getBillingSettled();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDelivery();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.serializeBinaryToWriter
    );
  }
  f = message.getKnownDefectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      videostory_render_service_pb.KnownDefect.serializeBinaryToWriter
    );
  }
  f = message.getFailure();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getRender();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      videostory_render_service_pb.Render.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNextSubmitTime();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCapacityRetries();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getHoldPlaced();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
};


/**
 * optional string schema = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getSchema = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setSchema = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string architectural_plan_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string graph_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string graph_version = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getGraphVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setGraphVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string look = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getLook = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setLook = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string language = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string video_key = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getVideoKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setVideoKey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string render_id = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getRenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setRenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 attempt = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getAttempt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setAttempt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional FindingVideoState state = 10;
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string state_detail = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getStateDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setStateDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string task_id = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string tenant = 13;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getTenant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setTenant = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional double estimated_cost_usd = 14;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getEstimatedCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setEstimatedCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double max_cost_usd = 15;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getMaxCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setMaxCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double render_cost_usd = 16;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getRenderCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setRenderCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double charged_usd = 17;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getChargedUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setChargedUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional bool billing_settled = 18;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getBillingSettled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setBillingSettled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional FindingVideoDelivery delivery = 19;
 * @return {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getDelivery = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery, 19));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setDelivery = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearDelivery = function() {
  return this.setDelivery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.hasDelivery = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated org.codetricks.construction.code.assistant.videostory.KnownDefect known_defects = 20;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getKnownDefectsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>} */ (
    jspb.Message.getRepeatedWrapperField(this, videostory_render_service_pb.KnownDefect, 20));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setKnownDefectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.addKnownDefects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.org.codetricks.construction.code.assistant.videostory.KnownDefect, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearKnownDefectsList = function() {
  return this.setKnownDefectsList([]);
};


/**
 * optional string failure = 21;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getFailure = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setFailure = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional org.codetricks.construction.code.assistant.videostory.Render render = 22;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getRender = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.Render} */ (
    jspb.Message.getWrapperField(this, videostory_render_service_pb.Render, 22));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.Render|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setRender = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearRender = function() {
  return this.setRender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.hasRender = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp create_time = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp update_time = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Timestamp next_submit_time = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getNextSubmitTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setNextSubmitTime = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.clearNextSubmitTime = function() {
  return this.setNextSubmitTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.hasNextSubmitTime = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional int32 capacity_retries = 26;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getCapacityRetries = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setCapacityRetries = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional bool hold_placed = 27;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.getHoldPlaced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.prototype.setHoldPlaced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.toObject = function(includeInstance, msg) {
  var f, obj = {
folderUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
videoUri: jspb.Message.getFieldWithDefault(msg, 2, ""),
subtitlesUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
transcriptUri: jspb.Message.getFieldWithDefault(msg, 4, ""),
manifestUri: jspb.Message.getFieldWithDefault(msg, 5, ""),
deliveredUri: jspb.Message.getFieldWithDefault(msg, 6, ""),
linksUri: jspb.Message.getFieldWithDefault(msg, 7, ""),
linksMarkdownUri: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery;
  return proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoUri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitlesUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranscriptUri(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestUri(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveredUri(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksUri(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksMarkdownUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVideoUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubtitlesUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranscriptUri();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManifestUri();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDeliveredUri();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLinksUri();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLinksMarkdownUri();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string folder_uri = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getFolderUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setFolderUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string video_uri = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getVideoUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setVideoUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subtitles_uri = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getSubtitlesUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setSubtitlesUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transcript_uri = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getTranscriptUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setTranscriptUri = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string manifest_uri = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getManifestUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setManifestUri = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string delivered_uri = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getDeliveredUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setDeliveredUri = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string links_uri = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getLinksUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setLinksUri = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string links_markdown_uri = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.getLinksMarkdownUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoDelivery.prototype.setLinksMarkdownUri = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest;
  return proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string graph_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoRequest.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
video: (f = msg.getVideo()) && proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.toObject(includeInstance, f),
started: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse;
  return proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinaryFromReader);
      msg.setVideo(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStarted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.serializeBinaryToWriter
    );
  }
  f = message.getStarted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional FindingVideo video = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.getVideo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.setVideo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.clearVideo = function() {
  return this.setVideo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.hasVideo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool started = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.getStarted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.StartFindingVideoResponse.prototype.setStarted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 2, ""),
includeServiceRenders: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest;
  return proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeServiceRenders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIncludeServiceRenders();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string graph_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include_service_renders = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.getIncludeServiceRenders = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoRequest.prototype.setIncludeServiceRenders = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
video: (f = msg.getVideo()) && proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.toObject(includeInstance, f),
serviceRendersList: jspb.Message.toObjectList(msg.getServiceRendersList(),
    videostory_render_service_pb.Render.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse;
  return proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinaryFromReader);
      msg.setVideo(value);
      break;
    case 2:
      var value = new videostory_render_service_pb.Render;
      reader.readMessage(value,videostory_render_service_pb.Render.deserializeBinaryFromReader);
      msg.addServiceRenders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.serializeBinaryToWriter
    );
  }
  f = message.getServiceRendersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      videostory_render_service_pb.Render.serializeBinaryToWriter
    );
  }
};


/**
 * optional FindingVideo video = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.getVideo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.setVideo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.clearVideo = function() {
  return this.setVideo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.hasVideo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated org.codetricks.construction.code.assistant.videostory.Render service_renders = 2;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.getServiceRendersList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>} */ (
    jspb.Message.getRepeatedWrapperField(this, videostory_render_service_pb.Render, 2));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.setServiceRendersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Render=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.addServiceRenders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.codetricks.construction.code.assistant.videostory.Render, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.GetFindingVideoResponse.prototype.clearServiceRendersList = function() {
  return this.setServiceRendersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
architecturalPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
graphId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest;
  return proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchitecturalPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArchitecturalPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGraphId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string architectural_plan_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.getArchitecturalPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.setArchitecturalPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string graph_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.getGraphId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoRequest.prototype.setGraphId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
video: (f = msg.getVideo()) && proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse;
  return proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.deserializeBinaryFromReader);
      msg.setVideo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo.serializeBinaryToWriter
    );
  }
};


/**
 * optional FindingVideo video = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.getVideo = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideo|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.setVideo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.clearVideo = function() {
  return this.setVideo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.CancelFindingVideoResponse.prototype.hasVideo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.findingvideo.FindingVideoState = {
  FINDING_VIDEO_STATE_UNSPECIFIED: 0,
  SUBMITTING: 1,
  QUEUED: 2,
  RENDERING: 3,
  SUCCEEDED: 4,
  FAILED: 5,
  CANCELLED: 6
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.findingvideo);
